import React from 'react';
import { IconButton, Tooltip, useTheme, makeStyles } from '@material-ui/core';
import { useStylesGlobal } from '../../pages/GlobalStyle.css';

const useStyles = makeStyles((theme) => ({
  primary: {
    color: theme.palette.getContrastText(theme.palette.primary.main),
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  secondary: {
    color: theme.palette.getContrastText(theme.palette.secondary.main),
    backgroundColor: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
  text: {
    color: theme.palette.text.primary,
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  outlined: {
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  contained: {
    color: theme.palette.getContrastText(theme.palette.primary.main),
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

const IconButtonStyled = ({ color, variant = 'contained', style, onClick, children, tooltipTitle, iconSize = 20, position = 'bottom' }) => { // bottom
  const theme = useTheme();
  const stylesGlobal = useStylesGlobal();
  const classes = useStyles(theme);

  let buttonClass;
  if (variant === 'text') {
    buttonClass = classes.text;
  } else if (variant === 'outlined') {
    buttonClass = classes.outlined;
  } else {
    buttonClass = color && stylesGlobal[color] ? stylesGlobal[color] : color === 'secondary' ? classes.secondary : classes.primary;
  }

  return (
    <Tooltip title={tooltipTitle || ''} placement={position}>
      <IconButton className={buttonClass} style={style} onClick={onClick}>
      {children && React.isValidElement(children) ? React.cloneElement(children, { style: { fontSize: iconSize } }) : null}
      </IconButton>
    </Tooltip>
  );
};

export default IconButtonStyled;
